<template>
  <el-dialog
    title="商品介绍"
    class="global-dialog"
    :visible.sync="showDlg"
    width="600px"
    :before-close="handleClose"
  >
    <div class="dlg-content">
      <el-form
        class="global-form  "
        v-loading="loading"
        style="padding:30px 40px 20px 20px"
        :model="formData"
        :rules="rules"
        ref="form2"
        label-width="120px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item prop="yxText" label="商品介绍">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4 }"
                placeholder="请输入商品介绍"
                v-model="formData.yxText"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    showDlg: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      formData: {
        yxText: ''
      },
      rules: {
        yxText: [
          {
            required: true,
            message: '请输入商品介绍',
            trigger: 'blur'
          }
        ]
      },
      loading: false
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true

      this.$axios
        .get(this.$apis.grainSpecifications.selectYxGdx)
        .then(res => {
          this.formData.yxText = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleClose() {
      this.$emit('closeDlg')
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        this.loading = true
        this.$axios
          .post(this.$apis.grainSpecifications.updateYxGdx, this.formData)
          .then(() => {
            this.handleClose()
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
